








































import { Vue, Component } from 'vue-property-decorator'

@Component({
  components: {}
})

export default class Translation extends Vue {
  accessToken =''
  languages = [re('中文(简体)', 'zs'), re('英语', 'en'), re('中文(繁体)', 'zt'), re('俄语', 'ru'), re('日语', 'ja'), re('韩语', 'ko'), re('法语', 'fr'), re('德语', 'de'), re('西班牙语', 'es'), re('葡萄牙语', 'pt'), re('阿拉伯语', 'ar'), re('意大利语', 'it'), re('泰语', 'th'), re('越南语', 'vi'), re('老挝语', 'lo'), re('芬兰语', 'fi'), re('马来语', 'ms'), re('土耳其语', 'tr'), re('印尼语', 'id'), re('希伯来语', 'he'), re('波兰语', 'pl'), re('荷兰语', 'nl'), re('挪威语', 'no'), re('捷克语', 'cs'), re('丹麦语', 'da'), re('保加利亚语', 'bg'), re('波斯语', 'fa'), re('维吾尔语', 'ug'), re('藏语', 'bo'), re('蒙语', 'mn'), re('缅甸语', 'my'), re('塞尔维亚语', 'sr'), re('印地语', 'hi'), re('高棉语', 'km'), re('泰米尔语', 'ta')]
  // eslint-disable-next-line camelcase
  src_language_type = 'zs'
  // eslint-disable-next-line camelcase
  tgt_language_type = 'en'
  ready =false
  loading = false
  text = ''
  file:any = null
  taskID = null
  result = ''
  docPath = ''
  mounted () {
    this.getToken()
  }
  getToken () {
    this.ready = false
    $.ajax({
      url: 'https://transapi.dl.wiki/oauth/access-token',
      method: 'get',
      data: {
        client_id: '2NlngoAHiJlnRliObaUcgPyhish6EgY6',
        client_secret: '0d40626c-5e5b-8b60-e7cf-480c3baef088'
      }
    }).then((res) => {
      this.accessToken = res.access_token
      const timer = setTimeout(() => {
        this.getToken()
      }, res.expires_in * 1000)
      this.$once('hook:beforeDestroy', () => {
        clearTimeout(timer)
        console.log('Destroy')
      })
      this.ready = true
      // $.ajax({
      //   url: 'https://transapi.dl.wiki/users/languages',
      //   method: 'get',
      //   headers: {
      //     authorization: `Bearer ${this.accessToken}`
      //   }
      // }).then((res) => {
      //   this.languages = res
      //   this.ready = true
      // })
    })
  }
  reversal () {
    let temp = this.tgt_language_type
    this.tgt_language_type = this.src_language_type
    this.src_language_type = temp
  }
  upload (e: { target: { files: any[] } }) {
    this.loading = true
    const formData = new FormData()
    formData.append('data', JSON.stringify({
      src_language_type: this.src_language_type,
      tgt_language_type: this.tgt_language_type,
      editable: 0
    }))
    formData.append('file', e.target.files[0])
    $.ajax({
      url: 'https://transapi.dl.wiki/translations/file',
      method: 'post',
      contentType: false,
      processData: false,
      headers: {
        authorization: `Bearer ${this.accessToken}`
      },
      data: formData
    }).then(res => {
      this.taskID = res
      const timer = setInterval(() => {
        $.ajax({
          url: `https://transapi.dl.wiki/translations/tasks/${this.taskID}`,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.accessToken}`
          }
        }).then(res => {
          if (res.progress.percent === 100) {
            clearInterval(timer)
            window.location.href = `https://transapi.dl.wiki/translations/tgt/${res.progress.file_lib_ids[0]}`
            // this.docPath = 'https://view.officeapps.live.com/op/embed.aspx?src=https://www.dl.wiki/files/1149684.docx'
            // $.ajax({
            //   url: `https://www.dl.wiki/api/trans/file/save/${res.progress.file_lib_ids[0]}/docx`,
            //   method: 'get',
            //   headers: {
            //     authorization: `Bearer ${this.accessToken}`
            //   }
            // }).then(() => {
            //   console.log(res)
            //   this.docPath = `https://view.officeapps.live.com/op/embed.aspx?src=https://www.dl.wiki/files/${res.progress.file_lib_ids[0]}.docx`
            //   this.loading = false
            // }, () => {this.docPath = `https://view.officeapps.live.com/op/embed.aspx?src=https://www.dl.wiki/files/${res.progress.file_lib_ids[0]}.docx`})
            // $.ajax({
            //   url: `https://transapi.dl.wiki/translations/tgt/${res.progress.file_lib_ids[0]}`,
            //   method: 'get',
            //   headers: {
            //     authorization: `Bearer ${this.accessToken}`
            //   }
            // }).then(res => {
            //   console.log(res)
            //   var blob = new Blob([res])
            //   var eleLink = document.createElement('a')
            //   eleLink.download = '3213.docx'
            //   eleLink.href = URL.createObjectURL(blob)
            //   eleLink.click()
            //   this.loading = false
            // })
          }
        })
      }, 2000)
    })
  }
  translation () {
    this.loading = true
    if (this.tgt_language_type === this.src_language_type) {
      alert('翻译语言类型不能相同')
      this.loading = false
      return
    }
    if (this.text === '') {
      alert('请输入需要翻译的内容')
      this.loading = false
      return
    }
    $.ajax({
      url: 'https://transapi.dl.wiki/translations/texts',
      method: 'post',
      contentType: 'application/json',
      headers: {
        authorization: `Bearer ${this.accessToken}`
      },
      data: JSON.stringify({
        texts: [this.text],
        src_language_type: this.src_language_type,
        tgt_language_type: this.tgt_language_type,
        other: ''
      })
    }).then((res) => {
      this.loading = false
      this.result = res.texts[0]
    }, (err) => {
      this.loading = false
      alert('翻译失败' + err.responseJSON.message)
    })
  }
}

function re (name:string, value:string) {
  return { name, value }
}
